(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sock-type-nav"] && !Shopify.designMode) return;
  try {
    
  const selectSockType = (root, typeId) => {
    if (!root || !typeId) return;

    root.querySelectorAll('[data-sock-type]').forEach((tab) => {
      const selected = tab.dataset.sockType === typeId;
      tab.classList.toggle('is-selected', selected);
      tab.setAttribute('aria-selected', selected ? 'true' : 'false');
    });

    root.querySelectorAll('[data-sock-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.sockPanel !== typeId;
    });

    root.querySelectorAll('[data-sock-header]').forEach((header) => {
      header.hidden = header.dataset.sockHeader !== typeId;
    });
  };

  const defaultSockType = (root) =>
    root?.querySelector('[data-sock-type]')?.dataset.sockType;

  const updateSockCartCount = (count) => {
    const value = Number(count) || 0;
    document.querySelectorAll('[data-sock-view-cart]').forEach((button) => {
      button.classList.toggle('has-items', value > 0);
      const badge = button.querySelector('[data-sock-cart-count]');
      if (badge) badge.textContent = value > 0 ? String(value) : '';
    });
  };

  const openSockCart = (event) => {
    const trigger = event.target.closest('[data-sock-view-cart]');
    if (!trigger) return;

    const drawer = document.querySelector('#cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      event.preventDefault();
      drawer.open();
      return;
    }

    const headerTrigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
    if (headerTrigger) {
      event.preventDefault();
      headerTrigger.click();
    }
  };

  const applySockFilter = (button) => {
    const panel = button.closest('[data-sock-panel]');
    if (!panel) return;

    const value = button.dataset.sockFilter;

    panel.querySelectorAll('[data-sock-filter]').forEach((chip) => {
      const selected = chip === button;
      chip.classList.toggle('is-selected', selected);
      chip.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });

    panel.querySelectorAll('[data-sock-subs]').forEach((card) => {
      const subs = card.dataset.sockSubs.split('|').filter(Boolean);
      card.hidden = value !== '' && !subs.includes(value);
    });
  };

  const setSockHoverImage = (thumb, showNext) => {
    const images = thumb.querySelectorAll('.sock-type-nav__image');
    if (images.length < 2) return;
    images[0].hidden = showNext;
    images[0].classList.toggle('is-active', !showNext);
    images[1].hidden = !showNext;
    images[1].classList.toggle('is-active', showNext);
  };

  document.addEventListener('mouseover', (event) => {
    const thumb = event.target.closest('[data-sock-hover]');
    if (!thumb || thumb.contains(event.relatedTarget)) return;
    setSockHoverImage(thumb, true);
  });

  document.addEventListener('mouseout', (event) => {
    const thumb = event.target.closest('[data-sock-hover]');
    if (!thumb || thumb.contains(event.relatedTarget)) return;
    setSockHoverImage(thumb, false);
  });

  const enterShopView = (typeId) => {
    const root = document.querySelector('.sock-type-nav');
    const types = document.querySelector('[data-sock-type-types]');
    if (!root || !types) return;

    root.classList.add('is-open');
    document.documentElement.classList.add('is-shop-view');
    selectSockType(root, typeId || defaultSockType(root));
    types.scrollIntoView({ behavior: 'instant', block: 'start' });
  };

  const openShopFromHash = () => {
    if (window.location.hash === '#shop') enterShopView();
  };

  const getProductModal = () => document.querySelector('[data-sock-modal]');
  const getProductModalBody = () => document.querySelector('[data-sock-modal-body]');
  const getModalSlides = () => [...(getProductModalBody()?.querySelectorAll('[data-sock-modal-slide]') || [])];

  const setModalSlide = (index) => {
    const slides = getModalSlides();
    if (!slides.length) return;

    const next = Math.min(Math.max(index, 0), slides.length - 1);
    slides.forEach((slide, slideIndex) => {
      slide.hidden = slideIndex !== next;
    });

    const modal = getProductModal();
    const prev = modal?.querySelector('[data-sock-modal-prev]');
    const forward = modal?.querySelector('[data-sock-modal-next]');
    const onlyOne = slides.length < 2;

    if (prev) {
      prev.hidden = onlyOne;
      prev.disabled = onlyOne || next === 0;
    }

    if (forward) {
      forward.hidden = onlyOne;
      forward.disabled = onlyOne || next === slides.length - 1;
    }
  };

  const stepModalSlide = (delta) => {
    const slides = getModalSlides();
    if (slides.length < 2) return;
    const current = Math.max(0, slides.findIndex((slide) => !slide.hidden));
    const next = current + delta;
    if (next < 0 || next >= slides.length) return;
    setModalSlide(next);
  };

  const closeProductModal = () => {
    const modal = getProductModal();
    if (!modal?.open) return;
    modal.close();
    const modalBody = getProductModalBody();
    if (modalBody) modalBody.innerHTML = '';
    document.body.style.removeProperty('overflow');
  };

  const openProductModal = (trigger) => {
    const modal = getProductModal();
    const modalBody = getProductModalBody();
    if (!modal || !modalBody) return;

    const scope = trigger.closest('.sock-type-nav__product, .sock-type-nav__header');
    const images = scope?.querySelector('[data-sock-modal-images]');
    if (!images) return;

    modalBody.replaceChildren(images.content.cloneNode(true));
    setModalSlide(0);
    modal.showModal();
    document.body.style.overflow = 'hidden';
  };

  const getSockQtyInput = (actions) =>
    actions.closest('.sock-type-nav__order')?.querySelector('[data-sock-qty-input]');

  const getSockButton = (actions) => actions.querySelector('[data-sock-cart-button]');

  const getSockQty = (actions) =>
    actions.closest('.sock-type-nav__order')?.querySelector('[data-sock-qty]');

  const setSockButton = (button, { label }) => {
    if (!button) return;
    const text = button.querySelector('[data-sock-cart-label]');
    button.type = 'button';
    if (text) text.textContent = label;
    else button.textContent = label;
    button.disabled = Boolean(button.dataset.soldOut);
    button.classList.remove('is-loading');
    button.removeAttribute('aria-busy');
  };

  const setSockLoading = (actions, loading) => {
    const button = getSockButton(actions);
    const qty = getSockQty(actions);
    const inCart = Number(actions.dataset.sockCartQty || 0) > 0;

    if (button && !button.dataset.soldOut && !inCart) {
      const text = button.querySelector('[data-sock-cart-label]');
      button.classList.toggle('is-loading', loading);
      button.toggleAttribute('aria-busy', loading);
      button.disabled = loading;
      if (text) text.textContent = loading ? 'Adding' : 'Add to cart';
    }

    if (qty) {
      qty.classList.toggle('is-loading', loading);
      qty.querySelectorAll('[data-sock-qty-minus], [data-sock-qty-plus], [data-sock-qty-input]').forEach((control) => {
        control.disabled = loading;
      });
    }

    if (loading) actions.dataset.sockBusy = 'true';
    else delete actions.dataset.sockBusy;
  };

  const setSockCartState = (actions, inCart, quantity, lineKey) => {
    if (!actions) return;
    const form = actions.closest('.sock-type-nav__order');
    const button = getSockButton(actions);
    const input = getSockQtyInput(actions);
    const qty = getSockQty(actions);

    form?.classList.toggle('is-in-cart', inCart);
    actions.dataset.sockCartQty = String(quantity || 0);
    if (lineKey) actions.dataset.sockLineKey = lineKey;
    if (!inCart) delete actions.dataset.sockLineKey;

    if (button) {
      if (button.dataset.soldOut) {
        button.hidden = false;
        setSockButton(button, { label: 'Sold out' });
      } else {
        button.hidden = inCart;
        setSockButton(button, { label: 'Add to cart' });
      }
    }

    if (qty) qty.hidden = !inCart;
    if (input && document.activeElement !== input) {
      input.value = String(quantity > 0 ? quantity : 1);
    }
    setSockLoading(actions, false);
  };

  const cartJsonUrl = () => `${window.Theme?.routes?.cart_url || '/cart'}.js`;
  const cartAddUrl = () => window.Theme?.routes?.cart_add_url || '/cart/add.js';
  const cartChangeUrl = () => window.Theme?.routes?.cart_change_url || '/cart/change.js';

  const notifySockCartChanged = (cart, action) => {
    const event = new CustomEvent('shopify:cart:lines-update', {
      bubbles: true,
      cancelable: true,
    });
    event.action = action;
    event.promise = Promise.resolve({
      cart: { totalQuantity: cart.item_count },
      detail: {
        items: cart.items,
        itemCount: cart.item_count,
        sections: cart.sections,
        source: 'sock-type-nav',
        didError: false,
      },
    });
    document.dispatchEvent(event);
  };

  const fetchSockCart = () =>
    fetch(cartJsonUrl(), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    }).then((response) => {
      if (!response.ok) throw new Error(`Cart fetch failed: ${response.status}`);
      return response.json();
    });

  const updateSockCart = (actions, nextQuantity) => {
    const input = getSockQtyInput(actions);
    const variantId = actions.dataset.sockVariant;
    const lineKey = actions.dataset.sockLineKey;
    const quantity = nextQuantity == null ? Number(input?.value || 0) : Number(nextQuantity);
    if (!variantId || actions.dataset.sockBusy === 'true') return;

    setSockLoading(actions, true);

    fetch(cartChangeUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: lineKey || Number(variantId),
        quantity,
      }),
    })
      .then((response) => response.json())
      .then((cart) => {
        if (cart.errors || cart.status) {
          throw new Error(cart.errors || cart.message || 'Cart update failed');
        }

        const item = (cart.items || []).find((line) => String(line.variant_id) === String(variantId));
        setSockCartState(actions, Boolean(item && item.quantity > 0), item?.quantity || 0, item?.key);
        updateSockCartCount(cart.item_count);
        notifySockCartChanged(cart, quantity > 0 ? 'update' : 'remove');
      })
      .catch(() => {
        setSockLoading(actions, false);
        if (input) input.value = actions.dataset.sockCartQty || '1';
      });
  };

  const commitSockQty = (actions) => {
    const input = getSockQtyInput(actions);
    if (!actions || !input) return;

    const current = Number(actions.dataset.sockCartQty || 0);
    const parsed = Number(input.value);
    if (!Number.isFinite(parsed)) {
      input.value = String(current || 1);
      return;
    }

    const max = input.max === '' ? Infinity : Number(input.max);
    const next = Math.min(max, Math.max(0, Math.round(parsed)));
    if (next === current) {
      input.value = String(current || 1);
      return;
    }

    updateSockCart(actions, next);
  };

  const addSockToCart = (actions) => {
    const variantId = actions?.dataset.sockVariant;
    const input = getSockQtyInput(actions);
    const quantity = Number(actions?.dataset.sockMin || input?.value || 1) || 1;
    if (!variantId || actions.dataset.sockBusy === 'true') return;

    setSockLoading(actions, true);

    fetch(cartAddUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: Number(variantId),
        quantity,
      }),
    })
      .then(async (response) => {
        const raw = await response.text();
        let data = null;
        try {
          data = JSON.parse(raw);
        } catch {
          throw new Error(`Cart returned ${response.status} (not JSON)`);
        }
        if (!response.ok || data.status || data.errors) {
          const errors = typeof data.errors === 'string' ? data.errors : JSON.stringify(data.errors || '');
          throw new Error(data.description || data.message || errors || `Cart returned ${response.status}`);
        }
        return fetchSockCart();
      })
      .then((cart) => {
        showSockError(actions, '');
        const item = (cart.items || []).find((line) => String(line.variant_id) === String(variantId));
        setSockCartState(actions, Boolean(item), item?.quantity || 0, item?.key);
        updateSockCartCount(cart.item_count);
        notifySockCartChanged(cart, 'add');
      })
      .catch((error) => {
        console.error('[sock-type-nav] add to cart failed', { variantId, quantity, error });
        setSockLoading(actions, false);
        showSockError(actions, error?.message || "Couldn't add to cart");
      });
  };

  const showSockError = (actions, message) => {
    const error = actions?.closest('.sock-type-nav__order')?.querySelector('[data-sock-error]');
    if (!error) return;
    error.textContent = message;
    error.hidden = !message;
  };

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target instanceof HTMLFormElement ? event.target : event.target.closest('form');
      if (!form?.classList.contains('sock-type-nav__order')) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const actions = form.querySelector('[data-sock-actions]');
      if (actions) addSockToCart(actions);
    },
    true
  );

  const applyCartItems = (items) => {
    document.querySelectorAll('[data-sock-actions]').forEach((actions) => {
      const variantId = actions.dataset.sockVariant;
      const item = (items || []).find((line) => String(line.variant_id) === String(variantId) && Number(line.quantity) > 0);
      setSockCartState(actions, Boolean(item), item?.quantity || 0, item?.key);
    });
  };

  const syncSockCartFromServer = (actions) =>
    fetchSockCart().then((cart) => {
        updateSockCartCount(cart.item_count);
        if (actions) {
          const item = (cart.items || []).find(
            (line) => String(line.variant_id) === String(actions.dataset.sockVariant) && Number(line.quantity) > 0
          );
          setSockCartState(actions, Boolean(item), item?.quantity || 0, item?.key);
          return;
        }
        applyCartItems(cart.items);
      });

  document.addEventListener('shopify:cart:lines-update', (event) => {
    if (event.detail?.source === 'sock-type-nav' || event.promise == null) {
      if (!event.promise) syncSockCartFromServer();
      return;
    }

    event.promise
      .then(({ cart, detail }) => {
        if (detail?.source === 'sock-type-nav') {
          updateSockCartCount(cart?.totalQuantity ?? detail?.itemCount);
          return;
        }
        updateSockCartCount(cart?.totalQuantity ?? detail?.itemCount);
        if (Array.isArray(detail?.items)) applyCartItems(detail.items);
        else syncSockCartFromServer();
      })
      .catch(() => syncSockCartFromServer());
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-sock-view-cart]')) {
      openSockCart(event);
      return;
    }

    const shop = event.target.closest('[data-sock-type-shop]');
    if (shop) {
      const root = shop.closest('.sock-type-nav');
      const types = root?.querySelector('[data-sock-type-types]');
      if (!types) return;

      event.preventDefault();
      root.classList.add('is-open');
      selectSockType(root, defaultSockType(root));
      types.scrollIntoView({ behavior: 'smooth', block: 'start' });

      let settled = false;
      const settle = () => {
        if (settled) return;
        settled = true;
        enterShopView(defaultSockType(root));
        if (window.location.hash !== '#shop') {
          history.pushState({ shopView: true }, '', '#shop');
        }
      };

      document.addEventListener('scrollend', settle, { once: true });
      setTimeout(settle, 600);
      return;
    }

    if (event.target.closest('[data-sock-modal-prev]')) {
      event.preventDefault();
      stepModalSlide(-1);
      return;
    }

    if (event.target.closest('[data-sock-modal-next]')) {
      event.preventDefault();
      stepModalSlide(1);
      return;
    }

    const addButton = event.target.closest('[data-sock-cart-button]');
    if (addButton && !addButton.disabled) {
      event.preventDefault();
      const actions = addButton.closest('[data-sock-actions]');
      if (actions) addSockToCart(actions);
      return;
    }

    const qtyButton = event.target.closest('[data-sock-qty-minus], [data-sock-qty-plus]');
    if (qtyButton) {
      event.preventDefault();
      const actions = qtyButton.closest('[data-sock-actions]');
      const input = getSockQtyInput(actions);
      if (!actions || !input) return;

      const step = Number(input.step || 1);
      const current = Number(actions.dataset.sockCartQty || 0);
      const max = input.max === '' ? Infinity : Number(input.max);
      const next = current + (qtyButton.hasAttribute('data-sock-qty-plus') ? step : -step);
      updateSockCart(actions, Math.min(max, Math.max(0, next)));
      return;
    }

    if (event.target.closest('[data-sock-close-modal]')) {
      event.preventDefault();
      closeProductModal();
      return;
    }

    if (event.target === getProductModal()) {
      closeProductModal();
      return;
    }

    const openModal = event.target.closest('[data-sock-open-modal]');
    if (openModal) {
      event.preventDefault();
      openProductModal(openModal);
      return;
    }

    const filter = event.target.closest('[data-sock-filter]');
    if (filter) {
      event.preventDefault();
      applySockFilter(filter);
      return;
    }

    const tab = event.target.closest('[data-sock-type]');
    if (!tab) return;

    event.preventDefault();
    selectSockType(tab.closest('.sock-type-nav'), tab.dataset.sockType);
  });

  document.addEventListener('change', (event) => {
    const input = event.target.closest('[data-sock-qty-input]');
    if (!input) return;
    const actions = input.closest('[data-sock-actions]');
    if (actions) commitSockQty(actions);
  });

  document.addEventListener('keydown', (event) => {
    const qtyInput = event.target.closest('[data-sock-qty-input]');
    if (qtyInput && event.key === 'Enter') {
      event.preventDefault();
      const actions = qtyInput.closest('[data-sock-actions]');
      qtyInput.blur();
      if (actions) commitSockQty(actions);
      return;
    }

    if (!getProductModal()?.open) return;
    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      stepModalSlide(-1);
    }
    if (event.key === 'ArrowRight') {
      event.preventDefault();
      stepModalSlide(1);
    }
  });

  document.addEventListener('close', (event) => {
    if (event.target !== getProductModal()) return;
    const modalBody = getProductModalBody();
    if (modalBody) modalBody.innerHTML = '';
    document.body.style.removeProperty('overflow');
  }, true);

  window.addEventListener('popstate', () => {
    if (window.location.hash === '#shop') {
      enterShopView();
      return;
    }

    document.documentElement.classList.remove('is-shop-view');
    document.querySelector('.sock-type-nav')?.classList.remove('is-open');
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', openShopFromHash, { once: true });
  } else {
    openShopFromHash();
  }

  } catch(e) { console.error(e); }
})();
})();
